import { createContext, useCallback, useMemo, useState } from 'react';
import type {
  InternalViewContextProps,
  InternalViewContextType,
} from '../../types/InternalViewContext.types';

const InternalViewContext = createContext<InternalViewContextType | null>(null);

const InternalViewProvider = ({ children }: InternalViewContextProps) => {
  const [internalViewerSuppliedShopperId, setShopperIdToView] =
    useState<string>('');

  const setInternalViewShopperId = useCallback(
    (shopperId: string) => {
      if (shopperId !== internalViewerSuppliedShopperId) {
        setShopperIdToView(shopperId);
      }
    },
    [internalViewerSuppliedShopperId]
  );

  const internalViewContextValues = useMemo(
    () => ({
      internalViewerSuppliedShopperId,
      setInternalViewShopperId,
    }),
    [internalViewerSuppliedShopperId, setInternalViewShopperId]
  );

  return (
    <InternalViewContext.Provider value={internalViewContextValues}>
      {children}
    </InternalViewContext.Provider>
  );
};

export { InternalViewContext, InternalViewProvider };
